/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImageSizeDto } from './ImageSizeDto';
import {
    ImageSizeDtoFromJSON,
    ImageSizeDtoFromJSONTyped,
    ImageSizeDtoToJSON,
} from './ImageSizeDto';

/**
 * 
 * @export
 * @interface GetTrimSignatureImageItemDto
 */
export interface GetTrimSignatureImageItemDto {
    /**
     * 
     * @type {string}
     * @memberof GetTrimSignatureImageItemDto
     */
    kind: GetTrimSignatureImageItemDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTrimSignatureImageItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetTrimSignatureImageItemDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTrimSignatureImageItemDto
     */
    status: GetTrimSignatureImageItemDtoStatusEnum;
    /**
     * 
     * @type {ImageSizeDto}
     * @memberof GetTrimSignatureImageItemDto
     */
    originalSize?: ImageSizeDto;
    /**
     * 
     * @type {ImageSizeDto}
     * @memberof GetTrimSignatureImageItemDto
     */
    trimmedSize?: ImageSizeDto;
    /**
     * 
     * @type {string}
     * @memberof GetTrimSignatureImageItemDto
     */
    error?: string;
}


/**
 * @export
 */
export const GetTrimSignatureImageItemDtoKindEnum = {
    Stamp: 'Stamp',
    EmployeeSign: 'EmployeeSign'
} as const;
export type GetTrimSignatureImageItemDtoKindEnum = typeof GetTrimSignatureImageItemDtoKindEnum[keyof typeof GetTrimSignatureImageItemDtoKindEnum];

/**
 * @export
 */
export const GetTrimSignatureImageItemDtoStatusEnum = {
    Trimmed: 'Trimmed',
    AlreadyTrimmed: 'AlreadyTrimmed',
    Empty: 'Empty',
    InvalidImage: 'InvalidImage'
} as const;
export type GetTrimSignatureImageItemDtoStatusEnum = typeof GetTrimSignatureImageItemDtoStatusEnum[keyof typeof GetTrimSignatureImageItemDtoStatusEnum];


/**
 * Check if a given object implements the GetTrimSignatureImageItemDto interface.
 */
export function instanceOfGetTrimSignatureImageItemDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "kind" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function GetTrimSignatureImageItemDtoFromJSON(json: any): GetTrimSignatureImageItemDto {
    return GetTrimSignatureImageItemDtoFromJSONTyped(json, false);
}

export function GetTrimSignatureImageItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTrimSignatureImageItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'status': json['status'],
        'originalSize': !exists(json, 'originalSize') ? undefined : ImageSizeDtoFromJSON(json['originalSize']),
        'trimmedSize': !exists(json, 'trimmedSize') ? undefined : ImageSizeDtoFromJSON(json['trimmedSize']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetTrimSignatureImageItemDtoToJSON(value?: GetTrimSignatureImageItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kind': value.kind,
        'id': value.id,
        'name': value.name,
        'status': value.status,
        'originalSize': ImageSizeDtoToJSON(value.originalSize),
        'trimmedSize': ImageSizeDtoToJSON(value.trimmedSize),
        'error': value.error,
    };
}

